<template>
  <div class="a-search-suggestion-links">
    <ListOfLinksWithHeading
      ref="suggestedSearches"
      :heading="suggestedSearchesHeading"
      :links="suggestedSearchesList"
      :modifiers="['inline']"
    />
  </div>
</template>

<script>
import { ListOfLinksWithHeading } from "@thegetty-private/getty-ui";
import { useLocalization } from "@thegetty-private/getty-ui";
import suggested_searches from "@data/suggested_searches";

export default {
  name: "SearchSuggestionLinks",
  components: {
    ListOfLinksWithHeading
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * The translated heading for the suggested searches list
       */
      suggestedSearchesHeading: this.translatePart(
        "suggested_search_list.heading"
      )
    };
  },
  computed: {
    /**
     * Gets the translated list of suggested searches
     *
     * @returns {array} - an array of link objects for suggested searches
     */
    suggestedSearchesList() {
      let suggestedSearchesList = suggested_searches.map((search) => {
        search.text = this.translatePart(search.text);
        return search;
      });
      return suggestedSearchesList;
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
